import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import MainLayout from "../../components/layout/MainLayout";
import StoresWithFilter from "../../components/home/stores-with-filter";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";

const AllStore = () => {
    const { configData, landingPageData, loading } = useConfigData();

    if (loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '18px'
            }}>
                Loading...
            </div>
        );
    }

    

    

    return (
        <>
            <CssBaseline/>
            <SEO
                title={configData ? `Home` : "Loading..."}
                image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
                businessName={configData?.business_name}
            />
            <MainLayout configData={configData} landingPageData={landingPageData}>
                <StoresWithFilter/>
            </MainLayout>
        </>
    );
};

export default AllStore;
